import { render, staticRenderFns } from "./liveWalletReport.vue?vue&type=template&id=5a70df60&scoped=true&"
import script from "./liveWalletReport.vue?vue&type=script&lang=js&"
export * from "./liveWalletReport.vue?vue&type=script&lang=js&"
import style0 from "./liveWalletReport.vue?vue&type=style&index=0&id=5a70df60&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a70df60",
  null
  
)

export default component.exports